module.exports = __webpack_public_path__ + "img/H000160_bluewhale.a5dbbfba.png";